import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { CRM_LeyendaAuditoria } from "./CRM_LeyendaAuditoria";
import { CRM_LeyendaDepartamento } from "./CRM_LeyendaDepartamento";
import { construirAuditoriaLocal } from "./construirAuditoriaLocal";

// Formulario vacío — usado cuando no hay cliente registrado (alta de cliente nuevo)
const FORM_VACIO = {
  clasificacion: "",
};

// Convierte info_General_cliente (Clientes/GetInfoClienteID) al formulario de esta pantalla
const mapClienteToForm = (cliente) => ({
  clasificacion: cliente?.clasificacion ?? "",
});

export const CRM_DetalleCredito = ({ esNuevo, idcliente, opcionesGenerales = { estatus: [], origen: [], tipo: [], clasificacion: [] }, cliente, soloLectura = false, responsableDepartamento = [] }) => {
  const { empleado } = useSelector((store) => store.usuario);
  const valorInicial = esNuevo ? FORM_VACIO : mapClienteToForm(cliente);
  const [editing, setEditing] = useState(esNuevo);
  const [form, setForm] = useState(valorInicial);
  const [auditoria, setAuditoria] = useState(cliente);

  useEffect(() => {
    setAuditoria(cliente);
  }, [cliente]);

  // cliente llega después del primer render (fetch async en CRM_DetalleScreen) — se sincroniza aquí
  useEffect(() => {
    if (esNuevo || !cliente) return;
    setForm(mapClienteToForm(cliente));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cliente]);

  const fieldClass = () => (editing ? "crm-field-editable" : "crm-field-readonly");

  const handleChange = (campo) => (e) => {
    setForm((prev) => ({ ...prev, [campo]: e.target.value }));
  };

  const handleEditar = () => setEditing(true);
  const handleCancelar = () => {
    setForm(valorInicial);
    setEditing(false);
  };

  const handleGuardar = () => {
    if (!form.clasificacion) {
      Swal.fire("CLIENTES", "Favor de seleccionar la clasificación del cliente", "warning");
      return;
    }

    const body = {
      idcliente: Number(idcliente),
      clasificacion: form.clasificacion,
    };

    request
      .post("Clientes/GuardarClasificacion", body)
      .then(async () => {
        await Swal.fire("CLIENTES", "Cambios guardados con éxito", "success");
        setAuditoria(construirAuditoriaLocal(empleado));
        setEditing(false);
      })
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"));
  };

  return (
    <div id="sec-credito" className="crm-detalle-card" style={{ scrollMarginTop: 170 }}>
      <div className="crm-detalle-card-header crm-detalle-card-header-actions">
        <div>
          <h3>Información de Crédito y Cobranza</h3>
          <p>Condiciones de crédito y cobranza del cliente</p>
        </div>
        <div className="crm-detalle-card-header-buttons">
          {editing ? (
            <>
              {!esNuevo && (
                <button type="button" className="btn-icono-ghost" title="Cancelar" onClick={handleCancelar}>
                  <CloseIcon />
                </button>
              )}
              <button type="button" className="btn-icono-solido" title="Guardar cambios" onClick={handleGuardar}>
                <CheckIcon />
                <span>Guardar</span>
              </button>
            </>
          ) : (
            !soloLectura && (
            <button type="button" className="btn-icono-ghost btn-editar" title="Editar" onClick={handleEditar}>
              <EditIcon />
              <span>Editar</span>
            </button>
            )
          )}
        </div>
      </div>

      <div className="crm-detalle-card-body">
        <div className="crm-detalle-grid crm-detalle-grid-1">
          <div className="crm-field">
            <label>Clasificación</label>
            <select className={fieldClass()} disabled={!editing} value={form.clasificacion} onChange={handleChange("clasificacion")}>
              <option value="">Seleccionar</option>
              {opcionesGenerales.clasificacion.map((o) => (
                <option key={o.id} value={o.id}>{o.valor}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="crm-detalle-card-footer">
        <CRM_LeyendaDepartamento responsables={responsableDepartamento} idrel={2} />
        <CRM_LeyendaAuditoria auditoria={auditoria} />
      </div>
    </div>
  );
};
